/* Bella Tu — recently viewed
 *
 * Records the PDPs a shopper has opened, in localStorage, and renders them back
 * on the product page: no app, works for guests, per-browser.
 *
 * Cards come from window.BTCard in card-loader.js, which has Shopify render the
 * theme's own product-card snippet, so a card here is the card on the grid.
 * card-loader.js is loaded first in the layout, and both are deferred, so order
 * is guaranteed.
 */
(function () {
  var KEY = 'bt_recently_viewed';
  var CAP = 12; // Plenty for any row length while keeping the entry small.

  function read() {
    try {
      var raw = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(raw) ? raw : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  function record(handle) {
    // Move to front rather than append, so the row is genuinely "recent" and
    // revisiting a product does not leave it stranded at the back.
    var list = read().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    write(list.slice(0, CAP));
  }

  function init() {
    var root = document.querySelector('[data-recently-viewed]');
    if (!root) return;

    var current = root.getAttribute('data-current') || '';
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 4;
    var grid = root.querySelector('[data-rv-grid]');

    // Read before recording, so the product being looked at right now is not
    // offered back to the shopper as something to revisit.
    var handles = read().filter(function (h) { return h !== current; }).slice(0, limit);
    if (current) record(current);

    if (!handles.length || !window.BTCard) return;

    BTCard.load(handles, 'card-row', grid.getAttribute('data-card-sizes')).then(function (results) {
      var shown = results.filter(function (r) { return r.el; });
      // Nothing loaded -- deleted, unpublished or unreachable: leave the
      // section hidden rather than showing an empty heading. Nothing is
      // pruned; this list only ever moves on.
      if (!shown.length) return;

      grid.replaceChildren.apply(grid, shown.map(function (r) { return r.el; }));
      root.hidden = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
